<template>
	<div>
		<div class="con-1334 box-white mt-30px accordion-view">
			<Accordion
				v-for="(accordion, index) in accordions"
				:key="index"
				:title="accordion.title"
				:baseShow="accordion.open"
				:class="accordion.class"
			>
				<ul v-if="accordion.hasItems">
					<li
						v-for="(item, index) in accordion.items"
						:key="index"
						:style="{ width: item.title === undefined ? '100%' : '33%' }"
					>
						<span v-if="item.title">{{ item.title }}:</span>
						<span :class="{ 'font-italic': item.value === null }">
							{{ item.value === null ? ' - ' : item.value }}
						</span>
					</li>
				</ul>
				<div class="d-flex flex-column items-center" v-else>
					<span class="d-block mt-12px" v-if="accordion.key !== 'beneficiaryData'">
						Nincs megjeleníthető adat.
					</span>
					<span
						class="d-block mt-12px accordion-link"
						v-if="accordion.key === 'outbuildings'"
						@click="handleNavigation('property-details', 2)"
					>
						Melléképületek hozzáadása
					</span>
					<span
						class="d-block mt-12px accordion-link"
						v-if="accordion.key === 'insuranceEvents'"
						@click="handleNavigation('package-information', 5)"
					>
						Kiegészítő biztosítások hozzáadása
					</span>
				</div>
				<span class="d-block mt-12px text-center" v-if="accordion.key === 'beneficiaryData'">
					A kiegészítő balesetbiztosítás a
					<a href="/pdf/mfo_kiegeszito_biztositasok.pdf" target="_blank">tájékoztató dokumentum</a>
					szerinti térítési limiteket tartalmazza.
				</span>
			</Accordion>
		</div>
		<div class="con-1334 navBtn">
			<LoadingButton text="Tovább a befejezéshez" class="navBtn-next btn btn-blue" @click="handleNext" :loading="loading" />
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import contractingRouter from '@/mixins/contractingRouter';
import SummaryView from '@/helpers/summaryView';
import LoadingButton from '@/components/elements/LoadingButton';
import Accordion from '@/components/Accordion';

export default {
    data() {
        return {
            loading: false,
        }
    },
	mixins: [contractingRouter],
	components: {
		LoadingButton,
		Accordion,
	},
	computed: {
		...mapGetters('contracting', [
			'getSelectedOffer',
			'getSelectedInsurerCode',
			'getInsurerCodes',
			'getCheckboxData',
			'getFormData',
			'getAllFormData',
		]),
		...mapGetters(['getCalculation']),
		accordions() {
			const summaryView = new SummaryView(
				this.getCalculation,
				this.getSelectedOffer,
				this.getAllFormData,
				this.$store,
			);
			return summaryView.getData();
		},
		hasBeneficiaryData() {},
	},
	methods: {
		...mapActions('contracting', ['saveNew']),
		...mapMutations(['setCurrentStep']),
		async beforeHandleNext() {
			return new Promise(async (resolve, reject) => {
                this.loading = true;
				const response = await this.saveNew({ summaryView: this.accordions, isLast: true });
                this.loading = false;
				if (response) {
					resolve('contracting-statement');
				}

			});
		},
		async beforeHandlePrev() {
			return new Promise(async (resolve, reject) => {
				if (this.getCalculation.real_estate.mortgage) {
					resolve('contracting-financing');
				}

				if (this.getCheckboxData('differentInsuredData')) {
					resolve('contracting-insured');
				}

				resolve('contracting-base');
			});
		},
		handleNavigation(route, currentStep) {
			this.setCurrentStep(currentStep);
			this.$router.push({ name: route });
		},
	},
};
</script>

<style lang="scss" scoped>
.con-1334 {
	padding-left: 0;
	padding-right: 0;
}

.navBtn-next {
	max-width: 220px;
}

.accordion-view {
	padding: 30px;

	@media only screen and (max-width: 1100px) {
		padding: 15px;
	}

	ul {
		display: flex;
		justify-content: flex-start;
		padding: 0;
		margin: 0;
		flex-wrap: wrap;
		list-style-type: none;

		@media only screen and (max-width: 1100px) {
			justify-content: flex-start;
		}

		li {
			width: 33%;
			padding: 7.5px;
			box-sizing: border-box;

			@media only screen and (max-width: 1100px) {
				width: 50% !important;
			}

			@media only screen and (max-width: 580px) {
				width: 100% !important;
			}

			span {
				display: inline-block;
				font-weight: 400;

				&:first-child {
					font-weight: 700;
				}
			}
		}
	}

	.accordion-link {
		font-size: 16px;
		line-height: 24px;
		max-width: 250px;
		width: 100%;
		min-height: 48px;
		font-weight: 500;
		box-sizing: border-box;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #1068eb !important;
		color: #ffffff !important;
		transition: 0.2s !important;
		cursor: pointer;
		text-align: center;
		text-decoration: none;
		padding: 10px 15px;
	}
}
</style>
